let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k8jhA")).then(() => parcelRequire('d3uR0'));